"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/components/StatusPill.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _broadcast = require('shared/enum/broadcast');
var _smsDelivery = require('shared/services/smsDelivery');

var _Tooltip = require('web/components/Tooltip');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

const displayStatusMap = {
  [_broadcast.broadcastMsgStatus.NOT_SCHEDULED]: 'Not scheduled',
  [_broadcast.broadcastMsgStatus.QUEUED]: 'Queued',
  [_broadcast.broadcastMsgStatus.PROCESSING]: 'Processing',
  [_broadcast.broadcastMsgStatus.FAILED]: 'Failed',
  [_broadcast.broadcastMsgStatus.COMPLETED]: 'Completed',
  [_broadcast.broadcastMsgStatus.AWAITING_CONSENT]: 'Waiting for consent',
}
const classNameSuffixMap = {
  [_broadcast.broadcastMsgStatus.NOT_SCHEDULED]: 'not-scheduled',
  [_broadcast.broadcastMsgStatus.QUEUED]: 'queued',
  [_broadcast.broadcastMsgStatus.PROCESSING]: 'processing',
  [_broadcast.broadcastMsgStatus.FAILED]: 'failed',
  [_broadcast.broadcastMsgStatus.COMPLETED]: 'completed',
  [_broadcast.broadcastMsgStatus.AWAITING_CONSENT]: 'awaiting-consent',
}

// Codes the server's verification gate records when it pauses a campaign.
 const gateErrorDescriptions = {
  org_not_verified: 'Campaign paused: campaigns are available once BloomText verifies this account.',
  contact_cap_reached: 'Campaign paused: this account reached its new-patient texting limit until BloomText verifies it.',
  verification_unavailable: "Campaign paused: we couldn't check this account's verification. Try again later.",
  // The patient was archived after they were added; broadcasts never text an archived patient.
  patient_archived: 'Not sent: the patient was archived.',
}; exports.gateErrorDescriptions = gateErrorDescriptions










const formatAskedDate = (iso) =>
  new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(new Date(iso))

/* Under the pill: why a Failed recipient wasn't texted, or when a waiting
 * one was asked for consent. */
const reasonOf = (status, code, askedAt) => {
  // A recipient BloomText won't text (D11): "Not deliverable: opted out".
  if (status === _broadcast.broadcastMsgStatus.FAILED) return _smsDelivery.broadcastErrorCodeText.call(void 0, code)
  if (status === _broadcast.broadcastMsgStatus.AWAITING_CONSENT) {
    return `${askedAt ? `Asked ${formatAskedDate(askedAt)} · ` : ''}sends when they reply YES`
  }
  return null
}

const StatusPill = ({ status, desc: code, isScheduled, askedAt = null }) => {
  // It shows under the pill, not only in the tooltip.
  const reason = reasonOf(status, code, askedAt)
  const desc = code && !reason ? _nullishCoalesce(exports.gateErrorDescriptions[code], () => ( code)) : null
  const label = (
    _react2.default.createElement('span', { className: "campaign--table--status-pill--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
      ,  isScheduled ? 'Scheduled' : displayStatusMap[status] 
    )
  )

  const content = desc
    ? (
        _react2.default.createElement(_Tooltip.HoverTooltip, {
          type: "dark",
          place: "top",
          content: _react2.default.createElement('span', { className: "campaign--table--tooltip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}},  desc ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}

          ,  label 
        )
      )
    : label

  const pill = (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 
      "campaign--table--status-pill",
      `campaign--table--status-pill-${isScheduled ? 'scheduled' : classNameSuffixMap[status]}`,
    ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
      ,  content 
    )
  )
  if (!reason) return pill

  return (
    _react2.default.createElement('div', { className: "campaign--table--status-cell", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
      ,  pill 
      , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 
        "campaign--table--status-reason",
        status === _broadcast.broadcastMsgStatus.AWAITING_CONSENT && "campaign--table--status-reason--quiet",
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
        ,  reason 
      )
    )
  )
}

exports. default = StatusPill
